import * as THREE from "three";
import Experience from "../Experience.js";

export default class Pencil {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("Pencil");
    }

    // Resource
    this.resource = this.resources.items.pencilModel;

    this.setModel();
  }

  setModel() {
    this.model = this.resource.scene;
    this.model.position.set(1.35, -0.316, 0.55);
    this.model.rotateY(0.9);
    this.model.scale.set(3, 3, 3);
    this.model.name = "pencil";

    this.scene.add(this.model);

    this.model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.name = this.model.name;
      }
    });
  }
}
